import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import findcare from '../../assests/findcare.png';
import { HOME_BANNER } from '../../shared/Strings';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Banner_Title = {
  Title: HOME_BANNER.TITLE_TEXT,
};

export default function FindCare() {
  let navigate = useNavigate();
  return (
    <Box
      onClick={() => {
        navigate('/care/findCare');
      }}
      sx={{
        width: { sm: '100%', xs: '100%' },
        cursor: 'pointer',
      }}>
      <Card
        sx={{
          bgcolor: '#FEC744',
          borderRadius: '12px',
          height: '72px',
        }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <CardContent sx={{ display: 'flex', textAlign: 'left' }}>
            <Typography
              sx={{
                typography: { sm: 'titleSmaller', xs: 'titleMobile' },
                mr: 1,
                ml: 3,
              }}>
              {Banner_Title.Title}
            </Typography>
            <ChevronRightIcon sx={{mt:'7px'}} />
          </CardContent>
          <CardMedia
            component="img"
            sx={{
              width: '98px',
              height: '72px',
              zIndex: '3',
            }}
            src={findcare}
            alt={HOME_BANNER.IMAGE_ALTERNATE_TEXT.Find_Care}
          />
        </Box>
      </Card>
    </Box>
  );
}
